const ApiPath = {
  Login: "ms-profile/user/login",
  AuthLogin: "v1/auth/login",
  AuthMe: "v1/auth/me",
  AuthMfaChallenge: "v1/auth/login/mfa/challenge",
  AuthMfaVerify: "v1/auth/login/mfa/verify",
  Logout: "ms-profile/user/logout",
  Refresh: "ms-profile/user/refresh",
  GetUser: "ms-profile/user",
  GetUsers: "ms-profile/user/users",
  StationPricing: "ms-price-capture/price-capture/admin",
  PriceCapture: "ms-price-capture/",
  GenerateReport: "ms-price-capture/report",
  GetCompetitors: "ms-price-capture/brand",
  GetStations: "ms-price-capture/station",
  Station: "ms-station/station",
  SurveyAnalyticsTotalProcessedResponses:
    "field-response-processed/analytics/total-processed-responses",
  SurveyAnalyticsCategoryDistribution: "field-response-processed/analytics/category-distribution",
  SurveyAnalyticsSentimentDistribution: "field-response-processed/analytics/sentiment-distribution",
  SurveyAnalyticsEmploymentSectorDistribution:
    "field-response-processed/analytics/employment-sector-distribution",
  SurveyAnalyticsKeyConcerns: "field-response-processed/analytics/key-concerns",
  SurveyAnalyticsAgeDistribution: "field-response-processed/analytics/age-distribution",
  SurveyAnalyticsSexDistribution: "field-response-processed/analytics/sex-distribution",
  SurveyAnalyticsEnumeratorPerformance: "field-response-processed/analytics/enumerator-performance",
  SurveyExecutiveSummaryReport: "field-response-processed/executive-summary-report",
  SurveyFieldResponsesProcessed: "field-response-processed",
  SurveyFieldResponsesProcessedFilterOptions: "field-response-processed/filter-options",
  SurveyFieldResponsesProcessedMapPoints: "field-response-processed/map-points",
  SurveyCampaign: "campaign",
  SurveyChatThread: "chat/thread",
  CohortGroup: "cohort-group",
  Cohort: "cohort",
};

export default ApiPath;
